import { render, staticRenderFns } from "./Adviser.vue?vue&type=template&id=0933cd75&scoped=true&"
import script from "./Adviser.vue?vue&type=script&lang=js&"
export * from "./Adviser.vue?vue&type=script&lang=js&"
import style0 from "./Adviser.vue?vue&type=style&index=0&id=0933cd75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0933cd75",
  null
  
)

export default component.exports